const useAppVersion = () => {
  const appVersion = import.meta.env.VITE_APP_VERSION;

  return appVersion;
};

export { useAppVersion };
